module.exports = __webpack_public_path__ + "img/galery-palm-x6-plus-1-zoom.3fc0e4ae.png";